import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { Alert, Checkbox, Col, DatePicker, Divider, Form, Modal, notification, Row } from "antd";
import dayjs, { Dayjs } from "dayjs";
import axios from "axios";
import { axiosErrorHandler } from "../../../../../swzutils";
import FormattedAddress from "../../../components/FormattedAddress";
import HelpLabel from "../../../components/HelpLabel";
import VehicleHirePaymentMethod from "../../../enums/VehicleHirePaymentMethod";
const TemplateToVehicleHireModal = (props) => {
    const [form] = Form.useForm();
    const [alert, contextHolder] = notification.useNotification();
    const [stateLoading, setStateLoading] = useState(false);
    const [stateErrorMessage, setStateErrorMessage] = useState(null);
    const createVehicleHire = (date, postOnMarketplace) => {
        const request = {
            date: date.format('YYYY-MM-DD'),
            postOnMarketplace
        };
        setStateLoading(true);
        axios.post(`/admin/v1/vehicle-hire-templates/${props.template.id}/instantiate`, request)
            .then(response => {
            props.onCreated(response.data);
        })
            .catch(error => {
            axiosErrorHandler(error, errorMessage => {
                alert.warning({
                    title: 'The vehicle may have been created however the a problem occurred',
                    description: errorMessage,
                    duration: 0 // Never close automatically
                });
                props.onCancel();
            });
        })
            .finally(() => {
            setStateLoading(false);
        });
    };
    const onFinish = (formValues) => {
        const hireDate = dayjs(formValues.hireDate.format("YYYY-MM-DD") + " " + props.template.hireFrom);
        if (formValues.postOnMarketplace && hireDate.isBefore(dayjs())) {
            setStateErrorMessage("The hire start date and time must be in the future to place the vehicle request on the marketplace.");
            return;
        }
        setStateErrorMessage(null);
        createVehicleHire(formValues.hireDate, formValues.postOnMarketplace);
    };
    const beforeToday = (selectedDate) => {
        return selectedDate && selectedDate < dayjs().startOf('day');
    };
    const startingSenderReceiver = props.template?.startingSenderReceiver;
    const customer = props.template?.customer;
    const deliverySenderReceiver = props.template?.deliverySenderReceiver;
    const paymentMethod = VehicleHirePaymentMethod.valueOf(props.template?.paymentMethod);
    const title = paymentMethod ? `Create ${paymentMethod.fullDescription} Vehicle Hire` : "Create Vehicle Hire";
    return (_jsxs(Modal, { title: title, open: props.open, confirmLoading: stateLoading, onCancel: props.onCancel, destroyOnHidden: true, onOk: () => form.submit(), okText: "Create Vehicle Hire", width: 650, children: [_jsxs(Form, { layout: "vertical", onFinish: onFinish, form: form, children: [customer &&
                        _jsx(Row, { children: _jsx(Col, { sm: 24, children: _jsxs("div", { children: [_jsx("h3", { className: "text-center", children: customer.name }), _jsx(Divider, {})] }) }) }), _jsxs(Row, { children: [_jsx(Col, { sm: 12, children: startingSenderReceiver &&
                                    _jsxs("div", { children: [_jsx("h4", { children: "Starting At" }), _jsx(FormattedAddress, { companyName: startingSenderReceiver.companyName, address: startingSenderReceiver.address })] }) }), _jsx(Col, { sm: 12, children: deliverySenderReceiver &&
                                    _jsxs("div", { children: [_jsx("h4", { children: "Delivering To" }), _jsx(FormattedAddress, { companyName: deliverySenderReceiver.companyName, address: deliverySenderReceiver.address })] }) })] }), _jsxs(Row, { children: [_jsx(Col, { sm: 24, children: _jsx(Form.Item, { name: "hireDate", label: "Hire Date", rules: [{
                                            required: true,
                                            message: 'Please select a hire date'
                                        }], children: _jsx(DatePicker, { format: "DD/MM/YYYY", showNow: false, disabledDate: beforeToday }) }) }), _jsx(Col, { sm: 24, children: _jsx(Form.Item, { name: "postOnMarketplace", initialValue: true, valuePropName: "checked", children: _jsx(Checkbox, { children: _jsx(HelpLabel, { title: "Post on marketplace and allocate to partner (if applicable)", helpText: "By selecting this checkbox the vehicle request will be posted on the marketplace and if the vehicle request has an allocated partner it will be allocated." }) }) }) })] }), stateErrorMessage ?
                        _jsx(Alert, { title: stateErrorMessage, type: "error", showIcon: true }) : null] }), contextHolder] }));
};
export default TemplateToVehicleHireModal;
